var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.type === 'button')?_c('b-button',{attrs:{"href":_vm.url}},[_vm._v(" Vai a cartella progetto ")]):_vm._e(),(_vm.type === 'link')?_c('b-link',{staticClass:"code",attrs:{"href":_vm.url}},[_vm._v(_vm._s(_vm.code))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }